import { constants } from './constants'
import { config } from '#/config';

export const mapDataSourceToAgent = (dataSourceAgent: string | null | undefined) => {
  if (!dataSourceAgent) {
    return ''
  }

  switch (dataSourceAgent) {
    case constants.agent.pggaLessonsLearned:
    case constants.agent.pgga:
    case constants.agent.pggall:
      return constants.mappedAgent.pgga
    case constants.agent.pgtrEngineering:
    case constants.agent.trafochat:
      return constants.mappedAgent.pgtrEngineering
    case constants.agent.structured:
      return constants.mappedAgent.structured
    case constants.agent.unstructured:
      return constants.mappedAgent.unstructured
    case constants.agent.ccrp:
      return constants.mappedAgent.ccrp
    case constants.agent.pghv:
      return constants.mappedAgent.pghv
    case constants.agent.pghvDatabases:
      return constants.mappedAgent.pghvDatabases
    case constants.agent.sapCoe:
      return constants.mappedAgent.sapCoe
    case constants.agent.digitalCoreCoe:
      return constants.mappedAgent.digitalCoreCoe
    case constants.agent.ror:
      return constants.mappedAgent.ror
    case constants.agent.lcNuclear:
      return constants.mappedAgent.lcNuclear
    case constants.agent.gpt5_gk:
      return constants.mappedAgent.gpt5_gk
    case constants.agent.pmcert:
      return constants.mappedAgent.pmcert
    case constants.agent.vayu:
      const title = localStorage.getItem('title')
      if (title === constants.mappedAgent.finance) {
        return constants.mappedAgent.finance
      }
      return constants.mappedAgent.scm
    case constants.agent.zaragoza:
      return constants.mappedAgent.zaragoza
    case constants.agent.hseincident:
      return constants.mappedAgent.hseincident
    case constants.agent.grcm:
      return constants.mappedAgent.grcm
    default:
      return ''
  }
}

export const mapAgentNameToAccessDeniedErrorMessage = (agentName: string | null | undefined) => {
  const fallbackMessage = `You do not have access to the Akira AI Chat, to use a general Akira capabilities please go to https://akira.hitachienergy.com`
  const defaultMessage = `You do not have access to the Akira ${agentName} Agent, to use a general Akira capabilities please go to https://akira.hitachienergy.com`
  const trafoChatMessage = `You do not have access to the Akira TrafoChat Agent.\n\n**To access TrafoChat:**\n1. Complete the [TrafoSchool Training](${config.env.TRAFOCHAT_TUTORIAL_URL}). Access will be granted within one week of training completion.\n2. Ensure you have access to the appropriate standards (technical, production, material, or quality depending on your role) in [Hitachi Energy Publisher](https://publisher.hitachienergy.com/). The answers of TrafoChat will only consider the documents you have access to.`;

  if (!agentName) {
    return fallbackMessage
  }

  switch (agentName) {
    case constants.mappedAgent.pgtrEngineering:
      return trafoChatMessage

    default:
      return defaultMessage
  }
}

/**
 * Maps data_source from history response to URL-safe agent names for routing
 * e.g., 'lc_nuclear' → 'nuclear-legal'
 */
export const mapDataSourceToUrlAgentName = (dataSource: string | null | undefined): string => {
  if (!dataSource) {
    return 'general'
  }

  const dataSourceLower = dataSource.toLowerCase()

  // Map data_source values to URL-safe agent names
  const sourceToUrlAgentMap: Record<string, string> = {
    // PGGA variants
    [constants.agent.pgga]: 'pgga',
    [constants.agent.pggall]: 'pggall',
    // TrafoChat/Engineering
    [constants.agent.pgtrEngineering]: 'trafochat',
    [constants.agent.trafochat]: 'trafochat',
    // Structured
    [constants.agent.structured]: 'projectinsight',
    [constants.agent.unstructured]: 'general',
    // CCRP
    [constants.agent.ccrp]: 'ccrp',
    // PGHV
    [constants.agent.pghv]: 'pghv',
    [constants.agent.pghvDatabases]: 'pghv_structure',
    // SAP
    [constants.agent.sapCoe]: 'digital_core_coe',
    // RoR
    [constants.agent.ror]: 'ror',
    // Nuclear Legal (special case - needs adjustment)
    [constants.agent.lcNuclear]: 'nuclear_legal',
    // GPT-5
    [constants.agent.gpt5_gk]: 'reasoning',
    // PM Cert
    [constants.agent.pmcert]: 'pmcert',
    // Zaragoza
    [constants.agent.zaragoza]: 'zaragoza',
    // HSE Incident
    [constants.agent.hseincident]: 'hse-incident',
    // GRCM
    [constants.agent.grcm]: 'grcm',
    // Digital Core
    [constants.agent.digitalCoreCoe]: 'digital_core_pm'
  }

  return sourceToUrlAgentMap[dataSourceLower] || 'general'
}